const styles = () => ({
  root: {
    backgroundColor: '#3C434A',
    flex: 'none',
    alignItems: 'center',
    width: 66,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'auto',

    // This can be removed with https://github.com/clearbit/clearkit-one/pull/60
    '& *:focus': {
      outline: 'none',
    },
  },

  xLogo: {
    flex: 'none',
    display: 'flex',
    justifyContent: 'center',
    margin: '28px 0 30px',
  },

  listItem: {
    position: 'relative',
    color: '#969BA1',
    fontSize: 20,
    height: 48,
    borderRadius: 6,
    padding: 0,
    width: 66,

    '& .nav-tooltip': {
      display: 'flex',
      transition: 'transformX(0px)',

      '&::before': {
        borderColor: 'transparent #C363E5 transparent transparent',
        borderStyle: 'solid',
        borderWidth: 16,
        content: '""',
        display: 'block',
        height: 0,
        left: '-31px',
        position: 'absolute',
        top: 0,
        width: 0,
      },
    },

    '&:hover .nav-tooltip': {
      visibility: 'visible',
      opacity: 1,
      transform: 'translateX(0px)',
    },
  },

  listItemTooltipContent: {
    background: 'linear-gradient(to left, #637EFF 0%, #C363E5 100%)',
    borderRadius: '2px 6px 6px 2px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, .15), 0 3px 15px rgba(0, 0, 0, .2)',
    color: '#fff',
    visibility: 'hidden',
    fontSize: '14px',
    fontWeight: '500',
    height: '32px',
    textAlign: 'center',
    lineHeight: '32px',
    left: '66px',
    opacity: 0,
    marginTop: -2,
    padding: '0 12px 0 8px',
    pointerEvents: 'none',
    position: 'fixed',
    transform: 'translateX(-8px)',
    transition: 'visibility 0s, opacity 0.3s ease, transform 0.3s ease',
    zIndex: 500,
  },

  listItemLabel: {
    display: 'none',
  },

  unstyledLink: {
    position: 'relative',
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    borderRadius: 'inherit',
    transition: 'color ease .2s',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 2,
      bottom: 2,
      left: 8,
      right: 8,
      borderRadius: 'inherit',
      transition: 'background-color ease .2s',
    },

    '& svg': {
      position: 'relative',
    },

    '&:hover': {
      color: 'rgba(255, 255, 255, .8)',

      '&::before': {
        backgroundColor: 'rgba(255, 255, 255, .05)',
      },
    },

    '&:focus': {
      color: 'rgba(255, 255, 255, .8)',

      '&::before': {
        backgroundColor: 'rgba(255, 255, 255, .05)',
      },
    },
  },

  listItemTextSelected: {
    color: '#FFF',

    '& svg': {
      fill: 'url(#gradient-br-x)',
    },

    '& a::before': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
    },

    '& a:hover::before': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
    },

    '& a:focus::before': {
      backgroundColor: 'rgba(0, 0, 0, .25)',
    },
  },

  spacer: {
    flex: '1 1 auto',
  },

  list: {
    flex: 'none',
  },

  companyIcon: {
    marginRight: 4,
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
    background: 'white',
  },

  lowerList: {
    flex: 'none',
    paddingTop: 24,
    paddingBottom: 18,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },

  companyListItem: {
    '& a::before': {
      left: 4,
      right: 4,
    },

    '& $listItemTooltipContent': {
      left: '74px',
    },
  },

  lowerListItemLink: {
    borderRadius: 5,
    color: '#969BA1',
    display: 'flex',
    fontSize: 18,
    height: 48,
    margin: '0 auto',

    '&:hover': {
      color: '#969BA1',
      backgroundColor: '#2b3237',
    },
  },

  lowerListItemLinkActive: {
    color: '#FFF !important',
  },

  paper: {
    left: '10px !important',
  },
});

export default styles;
